import { Route, Switch, useRouteMatch } from "react-router-dom";
import { useAppStore, useAppStoreMenuLinks } from "../../apis/appStore.hooks";
import { useContext } from "react";
import { AppContext } from "../../context/app";
import AppIframe from "./AppIframe";

function EmbeddedAppRouter() {
  const { client } = useContext(AppContext);
  const { data: apps = [], isLoading, error } = useAppStore();
  const { path } = useRouteMatch();

  const {
    data: menuLinks = [],
    isLoading: isLoadingMenuLinks,
    error: menuLinksError,
  } = useAppStoreMenuLinks(apps, client.uuid, {
    select: (data) => data.filter(({ dashboardLink }) => dashboardLink),
    enabled: apps.length > 0,
  });

  if (isLoading || isLoadingMenuLinks) {
    return null;
  }

  if (error || menuLinksError) {
    console.error(error || menuLinksError);
    return null;
  }

  return (
    <Switch>
      {menuLinks.map(({ slug, dashboardLink }) => (
        <Route
          path={`${path}/${slug}`}
          key={slug}
          render={() => <AppIframe src={dashboardLink} title={slug} />}
        />
      ))}
    </Switch>
  );
}

export default EmbeddedAppRouter;
